import { MobileOutlined, ExclamationCircleOutlined, DashboardOutlined, FileTextOutlined } from "@ant-design/icons";
import { useContext, useEffect, useState } from "react";
import ScreenContext from "../../themeContext/ScreenContext";
import UserContext from "../../themeContext/UserContext";
import { DashboardSecondaryHeaderData, GroupDocument } from "../../Types/dashboardTypes";
import "./dashboardSecondaryHeader.less";
import Dropdown from "../Dropdown/Dropdown";
import { HistoricalTsiDataType } from "../../Types/portalTypes";
import { getSubtractedDateStringValue } from "../../Common/commonFunctions";

interface Props {
  groupHistoricalData: HistoricalTsiDataType;
  groupDocument: GroupDocument;
  selectedGroup: string;
  setSelectedGroup: React.Dispatch<React.SetStateAction<string>>;
}
const DashboardSecondaryHeader: React.FC<Props> = (props) => {
  const { groupHistoricalData, groupDocument, selectedGroup, setSelectedGroup } = props;
  const screenSizeClassname = useContext(ScreenContext);
  const { userInfo } = useContext(UserContext);
  const [dashboardSecondaryHeaderData, setDashboardSecondaryHeaderData] = useState<DashboardSecondaryHeaderData>({
    numberOfDevices: "N/A",
    lastReport: "N/A",
    avgOee90: "N/A",
    numberErrorsLast30Days: "N/A",
  });
  const accountType = userInfo.accountType;

  // HISTORICAL data averge oee (day and week) is calculated here
  useEffect(() => {
    if (Object.keys(groupHistoricalData).length > 0) {
      let ninetyDayCount = 0;
      let ninetyDayOeeSum = 0;
      const ninetyDay = getSubtractedDateStringValue(90);
      Object.keys(groupHistoricalData).forEach((key) => {
        // do a ninetyDay average, then a weekly average
        groupHistoricalData[key].map((value) => {
          if (value.date > ninetyDay && value.oee) {
            ninetyDayCount += 1;
            ninetyDayOeeSum += value.oee;
          }
        });
      });
      setDashboardSecondaryHeaderData({
        ...dashboardSecondaryHeaderData,
        numberOfDevices: Object.keys(groupHistoricalData).length,
        avgOee90: Math.round((ninetyDayOeeSum / ninetyDayCount) * 100),
      });
    } else {
      setDashboardSecondaryHeaderData({
        ...dashboardSecondaryHeaderData,
        numberOfDevices: Object.keys(groupHistoricalData).length,
        avgOee90: "N/A",
      });
    }
  }, [groupHistoricalData, accountType]);

  return (
    <>
      {accountType == "free" ? (
        <div className={`secondary-header-main-div ${screenSizeClassname}`}>
          <div className="secondary-header-free-title">Facility 1</div>
          <div>
            <div className={`secondary-header-values ${screenSizeClassname}`}>
              {dashboardSecondaryHeaderData.numberOfDevices}
            </div>
            <div className="secondary-header-icon-keys">
              <MobileOutlined />
              <div className={`secondary-header-keys ${screenSizeClassname}`}>Devices</div>
            </div>
          </div>
          <div>
            <div className={`secondary-header-values ${screenSizeClassname}`}>
              {dashboardSecondaryHeaderData.avgOee90 == "N/A"
                ? dashboardSecondaryHeaderData.avgOee90
                : dashboardSecondaryHeaderData.avgOee90 + "%"}
            </div>
            <div className="secondary-header-icon-keys">
              <ExclamationCircleOutlined />
              <div className={`secondary-header-keys ${screenSizeClassname}`}>Avg OEE (last 90 days)</div>
            </div>
          </div>
          <div className="margin-bottom-50">
            <div className={`secondary-header-values ${screenSizeClassname}`}>
              {dashboardSecondaryHeaderData.numberErrorsLast30Days}
            </div>
            <div className="secondary-header-icon-keys">
              <DashboardOutlined />
              <div className={`secondary-header-keys ${screenSizeClassname}`}>Errors (last 30 days)</div>
            </div>
          </div>
        </div>
      ) : (
        <div className={`secondary-header-main-div ${screenSizeClassname}`}>
          <div style={{ margin: "20px 0px 0px 30px" }}>
            <Dropdown
              title={"Choose Group:"}
              onChange={(value) => setSelectedGroup(value as string)}
              options={groupDocument.groupNames.map((e) => ({
                label: e,
                value: e,
              }))}
              mainClassName={"group-dropdown-custom"}
              value={selectedGroup}
            />
          </div>

          <div>
            <div className={`secondary-header-values ${screenSizeClassname}`}>
              {dashboardSecondaryHeaderData.numberOfDevices}
            </div>
            <div className="secondary-header-icon-keys">
              <MobileOutlined />
              <div className={`secondary-header-keys ${screenSizeClassname}`}>Devices</div>
            </div>
          </div>
          <div>
            <div className={`secondary-header-values ${screenSizeClassname}`}>
              {dashboardSecondaryHeaderData.lastReport}
            </div>
            <div className="secondary-header-icon-keys">
              <FileTextOutlined />
              <div className={`secondary-header-keys ${screenSizeClassname}`}>Last Report</div>
            </div>
          </div>
          <div>
            <div className={`secondary-header-values ${screenSizeClassname}`}>
              {dashboardSecondaryHeaderData.avgOee90 == "N/A"
                ? dashboardSecondaryHeaderData.avgOee90
                : dashboardSecondaryHeaderData.avgOee90 + "%"}
            </div>
            <div className="secondary-header-icon-keys">
              <ExclamationCircleOutlined />
              <div className={`secondary-header-keys ${screenSizeClassname}`}>Avg OEE (last 90 days)</div>
            </div>
          </div>
          <div className="margin-bottom-50">
            <div className={`secondary-header-values ${screenSizeClassname}`}>
              {dashboardSecondaryHeaderData.numberErrorsLast30Days}
            </div>
            <div className="secondary-header-icon-keys">
              <DashboardOutlined />
              <div className={`secondary-header-keys ${screenSizeClassname}`}>Errors (last 30 days)</div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DashboardSecondaryHeader;
